export default __webpack_public_path__ + "static/media/plus-secondary.305f8ef1.svg";